import { clientFetch } from '@medifind/interface';

export const cspReport = ({ 'csp-report': cspReport }) => {
  return clientFetch(`/csp-report`, { method: 'POST', body: { 'csp-report': cspReport } });
};
